// src/admin/components/DateRangePicker.jsx
// `before` is the INCLUSIVE last day the user picks; runsApi turns it into the
// exclusive upper bound the backend expects (start of the next day).
import React from 'react';
import { COLORS, FONT_SANS, RADII } from '../../constants/theme.js';

const inputStyle = {
  padding: '6px 10px', borderRadius: RADII.controlInner,
  border: `1px solid ${COLORS.borderStrong}`, background: COLORS.surface,
  fontSize: '13px', fontFamily: FONT_SANS,
};

export default function DateRangePicker({ since, before, onChange }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <input type="date" value={since || ''} onChange={e => onChange({ since: e.target.value })} style={inputStyle} />
      <span style={{ color: COLORS.textSecondary, fontSize: '12px' }}>→</span>
      <input type="date" value={before || ''} onChange={e => onChange({ before: e.target.value })} style={inputStyle} />
    </div>
  );
}
